<template>
    <div class="draggable" v-if="(!task.omitted) || showOmitted ">
        <!-- Task Header. -->
        <div class="flex items-center mb-1">
            <div class="w-6 flex-shrink-0">
            </div>
            <div class="w-16">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    :class="((task.omitted) ? ' text-red-600 line-through':'') "
                >
                    <div class="font-semibold'" v-text="task.reference"></div>
                </div>
            </div>
            <div class="flex-1 ml-0">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 bg-white"
                    :class="((task.omitted) ? ' text-red-600 line-through':'')"
                >
                    <div v-text="task.name"></div>
                </div>
            </div>
            <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            </div>
        </div>

        <!-- Task Items. -->
        <scope-of-works-item v-for="item in task.items"
                             :section="section"
                             :task="task"
                             :showItemProgress="showItemProgress" :key="item.id"
                             :search="search"
                             :show-omitted="showOmitted"
                             :latest-progress-report="latestProgressReport"
                             :item="item"></scope-of-works-item>
        <div class="py-2"></div>
    </div>
</template>

<script>
import ScopeOfWorksItem from "./ScopeOfWorksItem.vue";

export default {
    components: {
        ScopeOfWorksItem,
    },
    props: {
        search: '',
        section: Object,
        task: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        latestProgressReport: Object,
    },
    data() {
        return {}
    },
    methods: {},
}
</script>
